import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=2725d874&"
import script from "./Organisation.vue?vue&type=script&lang=js&"
export * from "./Organisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BFormGroup, BCol, BFormTextarea, BButton, BRow, BForm} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BFormGroup, BCol, BFormTextarea, BButton, BRow, BForm})
    

export default component.exports